"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineSimpleTitle = void 0;
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderLineConfigSimpleTitle_1 = require("./getOrderLineConfigSimpleTitle");
const getOrderLineSimpleTitle = (item) => {
    if (!item.versions)
        return null;
    const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(item.versions);
    if (!latest_version)
        return null;
    return (0, getOrderLineConfigSimpleTitle_1.getOrderLineConfigSimpleTitle)(latest_version.config, item.type);
};
exports.getOrderLineSimpleTitle = getOrderLineSimpleTitle;
